// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "mail." + chunkId + "." + {"66":"2de4ff708a9951d9af32","458":"703057ee59b75457cf55","471":"5ddda6d4a08c14c3d5f0","862":"968c366ddf9b93fbe41d","904":"b94deda2336b7280a81e"}[chunkId] + ".js";
};